import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AjaxContext, AppContext } from 'commons-ui';
import {
	actionPerformedSuccessMessage,
	allertType,
	performSelectedActionURI
} from 'pages/dashboard/lottery/lotteryUploadCsv/utils/constants';

const useCreate = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName },
		showAlert
	} = useContext(AppContext);
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();

	const handleFormSubmit = async (submittedData: { [key: string]: string }) => {
		try {
			const body: { [key: string]: string } = { ...submittedData };
			setShowLoader(true);
			const response = await postData({
				endpoint: performSelectedActionURI,
				queryParams: {
					appName
				},
				body
			});
			const err: boolean = response?.data && response?.data?.success;
			if (!err) {
				showAlert(`${response?.data?.error}`, {
					type: allertType
				});
			} else {
				showAlert(actionPerformedSuccessMessage);
				history.goBack();
			}
		} catch (error: any) {
			showAlert(`${error?.response?.data?.error}`, { type: allertType });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
